'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002447 from "./presto.-Presto-Router$$anon$47.js";
import * as $j_presto$002e$002dRegister$002dPage$0024 from "./presto.-Register-Page$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$46() {
  this.bjP = null;
  this.bjH = null;
  this.bjI = false;
  this.bjQ = null;
  this.bjR = false;
  this.bjU = null;
  this.bjN = null;
  this.bjO = false;
  this.bjJ = null;
  this.bjK = false;
  this.bjL = null;
  this.bjM = false;
  this.bjS = false;
  this.bjT = false;
  this.bjP = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bjU = "RegisterPage";
}
export { $c_Lpresto_PrestoRouter$$anon$46 as $c_Lpresto_PrestoRouter$$anon$46 };
$p = $c_Lpresto_PrestoRouter$$anon$46.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$46;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$46() {
}
export { $h_Lpresto_PrestoRouter$$anon$46 as $h_Lpresto_PrestoRouter$$anon$46 };
$h_Lpresto_PrestoRouter$$anon$46.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bjP;
});
$p.M = (function() {
  if ((!this.bjI)) {
    this.bjH = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bjI = true;
  }
  return this.bjH;
});
$p.O = (function() {
  if ((!this.bjR)) {
    this.bjQ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bjR = true;
  }
  return this.bjQ;
});
$p.D = (function() {
  return this.bjU;
});
$p.t = (function() {
  if ((!this.bjO)) {
    this.bjN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bjO = true;
  }
  return this.bjN;
});
$p.N = (function() {
  if ((!this.bjK)) {
    this.bjJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bjK = true;
  }
  return this.bjJ;
});
$p.Q = (function() {
  if ((!this.bjM)) {
    this.bjL = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002447.$c_Lpresto_PrestoRouter$$anon$47();
    this.bjM = true;
  }
  return this.bjL;
});
$p.v = (function() {
  if ((!this.bjT)) {
    this.bjS = false;
    this.bjT = true;
  }
  return this.bjS;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee377) => ((p) => \u03b4scrutinee377))($j_presto$002e$002dRegister$002dPage$0024.$m_Lpresto_RegisterPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$46 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$46, "presto.PrestoRouter$$anon$46", ({
  Ol: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$46 as $d_Lpresto_PrestoRouter$$anon$46 };
//# sourceMappingURL=presto.-Presto-Router$$anon$46.js.map
